import { createClient, type SupabaseClient } from '@supabase/supabase-js';

/**
 * Somente a URL e a ANON KEY chegam ao bundle — ambas públicas por design.
 * `service_role` NUNCA aparece aqui, em `.env.example`, em log ou em commit.
 * O isolamento entre organizações é feito por RLS no Postgres, não por este
 * cliente. Ver docs/SEGURANCA-MULTITENANT.md.
 */
const url = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;

if (!url || !anonKey) {
  throw new Error(
    'Configuração ausente: defina VITE_SUPABASE_URL e VITE_SUPABASE_ANON_KEY (veja .env.example).',
  );
}

export const supabase: SupabaseClient = createClient(url, anonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    storageKey: 'nr12.auth',
  },
  global: {
    headers: { 'x-client-info': `nr12-web/${__APP_VERSION__}` },
  },
});

export const APP_VERSION = __APP_VERSION__;
